<template>
  <Box>
    <v-layout
      :style="{ 'min-height': `${minHeight}px` }"
      fill-height
      align-center
      justify-center
    >
      <div class="text--small text--center">
        <p><strong v-html="$t(`${namespace}.emptyState.title`)" /></p>
        <p class="mb-0">
          <span v-html="$t(`${namespace}.emptyState.text`)" /><br class="hidden-sm-and-down"><a href="https://99empresas.zendesk.com/hc/pt-br" :title="$t('Common.clickHere')" target="_blank">{{ $t('Common.clickHere') }}</a>&nbsp;<span v-html="$t(`${namespace}.emptyState.andKnowHow`)" />
        </p>
      </div>
    </v-layout>
  </Box>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    minHeight: {
      type: Number,
      default: 384
    }
  },
  data () {
    return {
      namespace: 'Components.Performance'
    }
  }
}
</script>
